/**
 * 挂件
 * @returns
 */
import { pendantApi } from '@/request';
import BaseServer from '@/domain/common/base.server';

class PendantServer extends BaseServer {
  constructor() {
    if (typeof PendantServer.instance === 'object') {
      return PendantServer.instance;
    }
    super();

    this.state = {
      pendantInfo: null
    };

    PendantServer.instance = this;
    return this;
  }

  // 获取挂件信息
  getPendantInfo(params = {}) {
    return pendantApi.getCustomPendantInfo(params).then(res => {
      res.data.custom_components = res.data.custom_components ? JSON.parse(res.data.custom_components) : {}
      this.state.pendantInfo = res.data
      return res;
    });
  }
}


export default function usePendantServer() {
  return new PendantServer();
}